export default "__VITE_PUBLIC_ASSET__51a51a23__"